<template>
	<li class="py-3">
		<div class="flex justify-between items-start">
			<div class="flex gap-10">
				<div>
					<div class="font-bold">{{ firma.denumire_firma }}</div>
					<div class="text-sm text-gray-500">{{ firma.cui }} | {{ firma.regcom }}</div>
				</div>
				<div>
					<div class="text-sm">{{ firma.adresa }}</div>
					<div class="text-sm text-gray-500">{{ firma.bank_account }} | {{ firma.bank }}</div>
				</div>
				<div>
					<div class="text-sm">{{ firma.person }}</div>
				</div>
			</div>
			<div class="flex items-center gap-3 flex-shrink-0">
				<div class="text-right mr-4">
					<div class="text-sm text-gray-500">Rulaj curent</div>
					<div class="font-bold text-sm">
						{{ firma.current_turnover | formatRon }}
						<span v-if="firma.turnover_threshold" class="font-normal text-gray-400">
							/ {{ firma.turnover_threshold | formatRon }}
						</span>
						<span v-else class="font-normal text-gray-400">/ fara limita</span>
					</div>
					<v-progress-linear v-if="firma.turnover_threshold" :value="turnoverPercent"
						:color="turnoverPercent >= 100 ? 'red' : turnoverPercent >= 80 ? 'orange' : 'teal'" height="4"
						class="mt-1" rounded></v-progress-linear>
				</div>
				<v-btn icon small @click="openEdit">
					<v-icon small>mdi-pencil</v-icon>
				</v-btn>
			</div>
		</div>

		<div v-if="editing" class="mt-3 flex items-center gap-4 bg-gray-50 p-3 rounded">
			<v-text-field v-model="editThreshold" class="w-44 flex-grow-0" label="Prag rulaj (EUR)" outlined dense
				hide-details type="number"></v-text-field>
			<v-checkbox v-model="resetTurnover" color="teal" label="Reseteaza rulaj curent" hide-details
				class="mt-0 flex-shrink-0"></v-checkbox>
			<v-btn color="teal" dark small @click="saveThreshold">Salveaza</v-btn>
			<v-btn small text @click="editing = false">Anuleaza</v-btn>
		</div>
	</li>
</template>

<script>
export default {
	name: "FirmaMontaj",
	props: ["firma"],
	data() {
		return {
			editing: false,
			editThreshold: null,
			resetTurnover: false,
		};
	},
	computed: {
		turnoverPercent() {
			if (!this.firma.turnover_threshold || !this.firma.current_turnover) return 0;
			return Math.min(100, (this.firma.current_turnover / this.firma.turnover_threshold) * 100);
		},
	},
	methods: {
		openEdit() {
			this.editThreshold = this.firma.turnover_threshold;
			this.resetTurnover = false;
			this.editing = true;
		},
		saveThreshold() {
			this.$store.dispatch("markFirmaActiva", {
				id_firma: this.firma.id_firma,
				turnover_threshold: this.editThreshold ? Number(this.editThreshold) : null,
				reset_turnover: this.resetTurnover,
			});
			this.editing = false;
		},
	},
};
</script>

<style scoped></style>
